module.exports = __webpack_public_path__ + "static/img/img-tuto-02.6b27d53b.png";